import React from 'react';
import HairColorApp from './HairColorApp';

function App() {
  return <HairColorApp />;
}

export default App;